import { render, staticRenderFns } from "./PriceSummary.vue?vue&type=template&id=1bd4d140&scoped=true"
import script from "./PriceSummary.vue?vue&type=script&lang=js"
export * from "./PriceSummary.vue?vue&type=script&lang=js"
import style0 from "./PriceSummary.vue?vue&type=style&index=0&id=1bd4d140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bd4d140",
  null
  
)

export default component.exports